/* Mehrsprachigkeit — Englisch, Deutsch, Französisch und Spanisch.
 *
 * Sprachwahl (Entscheidung Bastian, 2026-10-06): Ausgangssprache ist IMMER Englisch. Nur wer die
 * Sprache über die Auswahl umgestellt hat, bekommt seine gespeicherte Wahl (localStorage). Die Sprache
 * des Browsers wird nicht ausgewertet. Regel und Code: ./detect.js
 * Fachbezeichnungen bleiben unübersetzt: Positionsnamen ("Central Striker"),
 * Dokumentbezeichnungen ("Grassrunners Pass", "NFF", "Art. 19") und
 * "X11 Motion". Sie stehen so in Verbandsformularen — eine deutsche
 * Ersatzbezeichnung würde die Zuordnung erschweren.
 *
 * fr.json/es.json sind KI-erstellt und nicht muttersprachlich geprüft
 * (siehe CHANGELOG, Eintrag zur Einführung von Französisch/Spanisch).
 */

import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

import { detectLocale, FALLBACK_LOCALE } from './detect.js';

/* Auswahl und Speichern der Sprache: ./detect.js (hier weiter erreichbar) */
export { SUPPORTED_LOCALES, FALLBACK_LOCALE, LOCALE_STORAGE_KEY, detectLocale, persistLocale } from './detect.js';

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  /* Fehlende Übersetzungen sollen in der Entwicklung auffallen, im
     Produktivbetrieb aber nicht die Konsole fluten. */
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
  messages: { en, de, fr, es },
});
